// extracted by mini-css-extract-plugin
module.exports = {"message":"Message_message__z1tdG","default":"Message_default__RDDb4","warning":"Message_warning__FT9n8","error":"Message_error__WX2fA","success":"Message_success__Cnnxv"};
module.exports.__checksum = "e7c05ffe3613"
